import { map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService } from '../../core/service/backend/his-backend.service';

import { HisJobRequest } from '../model/his-job-request';
import { HisJobOption } from '../model/his-job-option';
import { HisJobHandle } from '../model/his-job-handle';
import { HisJobStatus } from '../model/his-job-status';
import { HisConversionUtils } from '../../core/utils';
import { HisJobProtocolChunk } from '../model/his-job-protocol-chunk';

@Injectable({providedIn: 'root'})
export class HisJobService {
    private hisBackendService = inject(HisBackendService);


    getAvailableJobs( key: string ): Observable<HisJobOption[]> {
        console.log( 'HisJobService.getAvailableJobs(): key =', key );
        return this.hisBackendService.getData( 'api/v1/cs/sys/jobConfig/optionsForStarter/' + key );
    }

    startJob( jobRequest: HisJobRequest ): Observable<HisJobStatus> {
        console.log( 'HisJobService.startJob(): request =', jobRequest );
        return this.hisBackendService.postData( 'api/v1/cs/sys/jobExecution', jobRequest );
    }

    getJobStatus( jobHandle: HisJobHandle ): Observable<HisJobStatus> {
        console.log( 'HisJobService.getJobStatus(): handle =', jobHandle );
        return this.hisBackendService.getData( 'api/v1/cs/sys/jobExecution/' + jobHandle.executionId ).pipe(
            map( ( status: HisJobStatus ) => {
                status.startedAt = HisConversionUtils.millisToDate( status.startedAt );
                status.finishedAt = HisConversionUtils.millisToDate( status.finishedAt );
                return status;
            } )
        );
    }

    getJobProtocol( jobHandle: HisJobHandle, startPos?: number, maxLines?: number ): Observable<HisJobProtocolChunk> {
        console.log( 'HisJobService.getJobProtocol(): handle =', jobHandle );

        let requestUrl = 'api/v1/cs/sys/jobExecution/' + jobHandle.executionId + '/log';
        requestUrl += '?startPos=' + ( startPos ? startPos : 0 );

        if ( maxLines && maxLines > 0 ) {
            requestUrl += '&maxLines=' + maxLines;
        }

        return this.hisBackendService.getData( requestUrl );
    }
}
